module.exports = __webpack_public_path__ + "banner.662692bca8ddc72c2b07bc7590b14b33.png";